// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import promise from 'es6-promise'
promise.polyfill()
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import moment from 'moment'
import Vuex from 'vuex'
import store from './store'
import ElementUI from 'element-ui'
import VueLazyload from 'vue-lazyload'
import 'element-ui/lib/theme-chalk/index.css';
import {commonIp, delCookie} from '@/assets/js/global.js'
import baseUrl from '@/utils/common.js'
import {storageData} from "@/assets/js/storage";

import  quillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import 'swiper/dist/css/swiper.css'
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
axios.defaults.withCredentials=true

Vue.prototype.$axios = axios
Vue.prototype.commonIp = commonIp
Vue.prototype.$baseUrl = baseUrl
Vue.prototype.delCookie = delCookie
Vue.use(ElementUI)
Vue.use(quillEditor)
Vue.use(VueLazyload)


Vue.use(Vuex)
Vue.filter('comverTime',function(data,format){
  return Moment(data).format(format);
});

import { fetchPost,fetchGet } from '@/utils/api'
Vue.prototype.$fetchPost= fetchPost;
Vue.prototype.$fetchGet= fetchGet;

let siteName = null
if(localStorage.getItem('navsObj')) {
  siteName = JSON.parse(localStorage.getItem('navsObj')).site.site_name
  document.title = siteName
}else if(localStorage.getItem('houseNavObj')) {
  siteName = JSON.parse(localStorage.getItem('houseNavObj')).site_name
  document.title = siteName
}


Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'houseNavObj') {

      // 创建一个StorageEvent事件
      var newStorageEvent = document.createEvent('StorageEvent');
      const storage = {
          setItem: function (k, val) {
              localStorage.setItem(k, val);

              // 初始化创建的事件
              newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

              // 派发对象
              window.dispatchEvent(newStorageEvent)
          }
      }
      return storage.setItem(key, newVal);
  }
}


router.beforeEach(function(to, from, next) {
  if(to.meta.needLogin) {//从cookie中获取用户信息，判断是否已登录
    if(storageData.getUserInfo().username) {
      next();//表示已经登录
    } else{//未登录
    //next可以传递一个路由对象作为参数 表示需要跳转到的页面
      next({
        path:'/arealogin'
      });
    }
  }else{
    //表示不需要登录
    if(to.meta.role == 'ishouse') {
      if (to.query.site_id) {
        sessionStorage.setItem('sId',to.query.site_id)
        next()
        return;
      }
      if (from.query.site_id) {
        sessionStorage.setItem('sId',from.query.site_id)
        let toQuery = JSON.parse(JSON.stringify(to.query));
        toQuery.site_id = from.query.site_id;
        next({
          path: to.path,
          query: toQuery
        })
      } else {
        next()
      }
    }else{
      next()
    }
  }
  
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js